import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrderDetailMap from '@atom/components/common/workOrderDetail/workOrderDetailMap/WorkOrderDetailMap';
import WorkOrderFields from '@atom/components/common/workOrderDetail/workOrderFields/WorkOrderFields';
import WorkOrderContext, {
  WorkOrderActionTypes,
} from '@atom/components/workOrderDetail/WorkOrderContext';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import DetailPane from './DetailPane';
import SummaryPane from './SummaryPane';

import classes from './workOrderInfo.module.css';

const WorkOrderInfo = () => {
  const { workOrderDetail, refetch, loading, dispatch } =
    useContext(WorkOrderContext);

  const showFields =
    hasRolePermissions(ROLE_SETS.INSPECTOR) || !workOrderDetail.workTemplateId;

  return (
    <div className={classes.infoContainer}>
      {workOrderDetail.isLocationBased ? (
        <>
          <div className={clsx(classes.pane, classes.left)}>
            <SummaryPane />
            {showFields && (
              <WorkOrderFields
                workOrderDetail={workOrderDetail}
                dispatch={dispatch}
                WorkOrderActionTypes={WorkOrderActionTypes}
              />
            )}
            <DetailPane />
          </div>
          <div className={classes.pane}>
            <WorkOrderDetailMap
              workOrderDetail={workOrderDetail}
              refetch={refetch}
              loading={loading}
            />
          </div>
        </>
      ) : (
        <div className={classes.noLocationPane}>
          <SummaryPane />
          {showFields && (
            <WorkOrderFields
              workOrderDetail={workOrderDetail}
              dispatch={dispatch}
              WorkOrderActionTypes={WorkOrderActionTypes}
            />
          )}
          <DetailPane />
        </div>
      )}
    </div>
  );
};

export default WorkOrderInfo;
